<template>
  <div class="image-container" ref="imageContainer">

    <!-- ⭐ ESTRELLAS -->
    <img ref="star1" src="@/assets/es.png" class="star star-1" />
    <img ref="star2" src="@/assets/es.png" class="star star-2" />
    <img ref="star3" src="@/assets/es.png" class="star star-3" />
    <img ref="star4" src="@/assets/es.png" class="star star-4" />

    <img 
      ref="image"
      src="@/assets/IMG_0646_11zon.webp"
      alt="Imagen de ejemplo"
      class="cover-image"
    >
    <div class="overlay"></div>
    
    <div ref="textRef" class="text-overlay">
      <p class="firma">
        Con cariño,<br>
        <span>Emily Rojas</span>
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'CoverImageComponent',
  setup() {
    const image = ref(null);
    const textRef = ref(null);
    const imageContainer = ref(null);

    // ⭐ estrellas
    const star1 = ref(null);
    const star2 = ref(null);
    const star3 = ref(null);
    const star4 = ref(null);

    onMounted(() => {
      gsap.fromTo(
        image.value,
        { opacity: 0, scale: 1.1 },
        { 
          opacity: 1, 
          scale: 1, 
          duration: 1.5, 
          ease: 'power2.out',
          scrollTrigger: {
            trigger: imageContainer.value,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );

      gsap.fromTo(
        textRef.value,
        { opacity: 0, y: 50 },
        { 
          opacity: 1, 
          y: 0, 
          duration: 1.8, 
          delay: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: imageContainer.value,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );

      // ✨ ANIMACIÓN ESTRELLAS
      const stars = [star1.value, star2.value, star3.value, star4.value];

      stars.forEach((star, i) => {
        if (!star) return;

        gsap.to(star, {
          y: '+=10',
          duration: 2 + i * 0.3,
          repeat: -1,
          yoyo: true,
          ease: 'sine.inOut'
        });

        gsap.fromTo(
          star,
          { opacity: 0.5, scale: 0.8 },
          {
            opacity: 1,
            scale: 1.2,
            duration: 2,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          }
        );
      });
    });

    return { textRef, image, imageContainer, star1, star2, star3, star4 };
  },
};
</script>

<style scoped>
.image-container {
  width: 100vw;
  height: 700px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ⭐ ESTRELLAS */
.star {
  position: absolute;
  width: 122px;
  pointer-events: none;
  z-index: 2; /* 🔥 no tapa texto */
  opacity: 0.8;
}

.star-1 { top: 0px; left: -19px; }
.star-2 { top: 0px; right: -19px; }
.star-3 { bottom: 80px; left: -19px; }
.star-4 { bottom: 40px; right: -19px; }

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  filter: brightness(80%);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.text-overlay {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
  color: #fff;
  z-index: 10;
  opacity: 0;
  padding: 0 20px;
}

.subtitle {
  font-size: 20px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 300;
  letter-spacing: 1px;
  margin-bottom: 15px;
}

.firma {
  font-size: 16px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 400;
  margin: 0;
}

.firma span {
  display: block;
  margin-top: 5px;
  font-family: 'FeelingPassionate';
  font-size: 3rem;
}
</style>